<template>
  <div class="cat-manager">
    <h3>Katalog Kategori Yönetimi</h3>
<p>Ürünlerin ana türleri. Örneğin "Microblading Pigments" ya da "Lip Pigments" gibi</p>
<div>
        <h4>{{ isEdit ? "Kategoriyi Güncelle" : "Yeni Kategori Ekle" }}</h4>
    <form @submit.prevent="isEdit ? updateCategory() : createCategory()">
      <input v-model="selected.cat_id" type="hidden" />
      <input v-model="selected.name" placeholder="Kategori Adı" required />
      <textarea v-model="selected.description" placeholder="Açıklama"></textarea>

      <button type="submit">{{ isEdit ? "Güncelle" : "Ekle" }}</button>
      <button v-if="isEdit" @click="cancelEdit" type="button">İptal</button>
    </form>
</div>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Adı</th>
          <th>Açıklama</th>
          <th>Oluşturulma</th>
          <th>Güncellenme</th>
          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in categories" :key="c.cat_id">
          <td>{{ c.cat_id }}</td>
          <td>{{ c.name }}</td>
          <td>{{ c.description || "-" }}</td>
          <td>{{ formatDate(c.created_at) }}</td>
          <td>{{ formatDate(c.updated_at) }}</td>
          <td>
            <button @click="editCategory(c)">Düzenle</button>
            <button class="delete" @click="deleteCategory(c.cat_id)">Sil</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CatalougeCategoryManager",
  data() {
    return {
      categories: [],
      selected: {
        cat_id: null,
        name: "",
        description: ""
      },
      isEdit: false
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await axios.get("/admin/promo/catalouge/cats");
        this.categories = res.data.data || [];
      } catch (e) {
        console.error("Kategoriler alınırken hata:", e);
      }
    },
    async createCategory() {
      try {
        await axios.post("/admin/promo/catalouge/cat", {
          name: this.selected.name,
          description: this.selected.description
        });
        await this.fetchCategories();
        this.resetForm();
      } catch (e) {
        console.error("Kategori oluşturulurken hata:", e);
      }
    },
    async updateCategory() {
      try {
        await axios.put(`/admin/promo/catalouge/cat/${this.selected.cat_id}`, {
          name: this.selected.name,
          description: this.selected.description
        });
        await this.fetchCategories();
        this.resetForm();
      } catch (e) {
        console.error("Kategori güncellenirken hata:", e);
      }
    },
    async deleteCategory(cat_id) {
      if (confirm("Bu kategoriyi silmek istediğinize emin misiniz? UYARI: Bağlı ürünler de silinebilir.")) {
        try {
          await axios.delete(`/admin/promo/catalouge/cat/${cat_id}`);
          await this.fetchCategories();
        } catch (e) {
          console.error("Kategori silinirken hata:", e);
        }
      }
    },
    editCategory(cat) {
      this.selected = { ...cat };
      this.isEdit = true;
    },
    resetForm() {
      this.selected = { cat_id: null, name: "", description: "" };
      this.isEdit = false;
    },
    cancelEdit() {
      this.resetForm();
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    }
  },
  mounted() {
    this.fetchCategories();
  }
};
</script>
 
